import React from "react";
import {api} from "../utils/gashtaltAPI";
import {toast} from "react-toastify";
import ImageViewer from "./ImageViewer";

function Question({id,index, text, image, options,showUnder = false,selectedOption=null,setOption,sendingOptions}) {
    const onOptionChange = async (option_id,option_index) => {
        try {
            setOption(index,option_index)
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
            selectedOption=0
        }
    }
    return (
        
        <div className="question nazanin">
        <div className="d-flex flex-row">
            <span class="me-3 bold">{index + 1})</span>
            <div className="d-flex flex-column flex-fill  col-12">
            <div
            dangerouslySetInnerHTML={{
              __html: `${text}`,
            }}
            className={"text flex-fill"}
            ></div>
            <div className="row justify-content-between col-12" dir={"ltr"}>
            {image !== null && (
                <ImageViewer src={image} alt={"تصویر"} className={"col-lg-6"} />
            )}
                <ul className={`${image ? 'col-lg-6' : 'col-12'} ${showUnder ? 'd-flex flex-row  justify-content-start option-lined' : ''}`} dir={'rtl'}>
                {options.map((option, option_index) => (
                        <li key={option.id} className={`align-items-start ${selectedOption === option_index ? 'selected' : ''} `}><span
                            className={`counter ${sendingOptions[index] === option_index ? "sending" : ""}`} onClick={() => {
                            onOptionChange(option.id, option_index)
                        }}><div>{option_index + 1}</div></span>{option.option}</li>
                    ))}
                </ul>
            </div>
        </div>

        </div>
        </div>
    );
}

export default Question;